import { cellText } from "./cellValue";
import type { Column } from "./DataTableTypes";

/** Semicolon, so spreadsheet apps using a decimal comma open the file without asking. */
const CSV_SEPARATOR = ";";
const CSV_LINE_BREAK = "\r\n";
/** Tells spreadsheet apps the file is UTF-8. */
const BYTE_ORDER_MARK = "﻿";
const NEEDS_QUOTES = /[";\n\r]/;
const ISO_DATE_LENGTH = "yyyy-mm-dd".length;

export const CSV_MIME_TYPE = "text/csv;charset=utf-8";

/** Quotes a field when it contains a quote, the separator or a line break. */
export function csvEscape(value: string): string {
  return NEEDS_QUOTES.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

/** Columns that go into the export: never actions, and not those opted out. */
export function csvColumns<R>(columns: Column<R>[]): Column<R>[] {
  return columns.filter((c) => c.type !== "actions" && c.csv !== false);
}

function csvLine(fields: string[]): string {
  return fields.map(csvEscape).join(CSV_SEPARATOR);
}

/** CSV document with a header line and one line per row, as the cells read. */
export function buildCsv<R>(columns: Column<R>[], rows: R[]): string {
  const cols = csvColumns(columns);
  const lines = [csvLine(cols.map((c) => c.label)), ...rows.map((row) => csvLine(cols.map((c) => cellText(row, c))))];
  return `${BYTE_ORDER_MARK}${lines.join(CSV_LINE_BREAK)}`;
}

/** `<prefix>-<yyyy-mm-dd>.csv`, dated in UTC. */
export function csvFileName(prefix: string, date: Date): string {
  return `${prefix}-${date.toISOString().slice(0, ISO_DATE_LENGTH)}.csv`;
}
